import { Alert } from '@thames-water/component-library'
import React, { lazy, Suspense } from 'react'
import { DataAttributes } from '../appConfig/dataAttributes'
import { entrypoints } from '../appConfig/entrypoints'
import { useDataAttributes } from '../hooks/useDataAttributes/useDataAttributes'
import { entrypointExists } from '../utils/entrypointExists/entrypointExists'

type LazyComponentType = React.LazyExoticComponent<React.ComponentType<any>>

const AppEntryPoint = () => {
    const { entrypoint } = useDataAttributes<DataAttributes>()

    if (!entrypointExists(entrypoint)) return <Alert>Entrypoint "{entrypoint}" is not configured in <code>src/appconfig/entrypoints</code>.</Alert>

    const Application: LazyComponentType = lazy(entrypoints[entrypoint])

    return (
        <Suspense fallback={<Alert>Loading application...</Alert>}>
            <Application />
        </Suspense>
    )
}

export { AppEntryPoint }
